export enum BannerColor {
    azzurro = 'AZZURRO',
    viola = 'VIOLA',
    giallo = 'GIALLO',
    arancione = 'ARANCIONE',
    verde = 'VERDE'
}